import React, { useEffect, useRef, useState } from "react";
import './Project.css';
import githubImage from '../assets/images/GitHub-Mark-Light-64px.png';
import websiteImage from '../assets/images/website.png'

export default function Project(props) {
    let projectRef = useRef();
    let [isVisible, setVisible] = useState(false);
    const options = {
        root: null,
        rootMargin: '0px',
        threshold: .6
    }

    useEffect(() => {
        let observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if(entry.isIntersecting){ setVisible(true); }
        }, options);
        observer.observe(projectRef.current);
    });

    function githubLink() {
        if(props.item.github){
            return <a className="project-link" target="noreferrer" href={props.item.github}><img src={githubImage} alt="github logo"/></a>;
        }
    }

    function websiteLink() {
        if(props.item.website){
            return <a className="project-link" target="noreferrer" href={props.item.website}><img src={websiteImage} alt="github logo"/></a>;
        }
    }

    const tech = props.item.tech.map((item) => {
        return <img className="tech-stack-image" src={item} alt='Tech stack logo(as described in about me)'></img>
    });

    return(
        <div ref={projectRef}>
            <div className={
                `project 
                ${props.isLeft ? "left": "right"} 
                ${isVisible && !props.isLeft ? "become-visible-right": ""} 
                ${isVisible && props.isLeft ? "become-visible-left": ""}`
            }>
                <div className="img-div">
                    <img className={`project-img ${props.isLeft? "image-right": "image-left"}`} src={props.item.thumbnail} alt={props.item.alt}/>
                    <div className="project-link-div">
                        {githubLink()}
                        {websiteLink()}
                    </div>
                </div>
                <div className="project-text">
                    <h1>{props.item.title}</h1>
                    <h4>{props.item.type}</h4>
                    <p>{props.item.text}</p>
                    <div className="tech-stack">
                        {tech}
                    </div>
                </div>
            </div>
        </div>
    );
}
